const LEVEL_COLOR = {
    error: '#cc5d24',
    info: '#6497f3',
    warn: '#ebc825',
};

class Log {

    generateMessage(level, messages) {
        if (process.env.NODE_ENV === 'production' && level !== 'error') {
            return;
        }

        console.log(`%c [${new Date()}]` + `%c ${level}`, 'color: #ccc', `color: ${LEVEL_COLOR[level]}; font-weight: bold`, ...messages);
    }

    info(...messages) {
        return this.generateMessage('info', messages);
    }

    warn(...messages) {
        return this.generateMessage('warn', messages);
    }

    error(...messages) {
        return this.generateMessage('error', messages);
    }
}

export default new Log();
